module.exports = __webpack_public_path__ + "static/media/fleetCompanies.ad82fe9d.svg";